import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { format } from 'date-fns';

import { Button, Loader, Table } from '@itds/elements/index.js';

import NewBuildDrawer from './NewBuildDrawer';

const Builds = ({ loadBuilds, builds, headers, mobile_app, page, setPage }) => {
  const navigate = useNavigate();
  const [show_new_build, toggleNewBuild] = useState();

  const handleBuildSave = () => {
    toggleNewBuild(false);
    loadBuilds();
  };

  return builds ? (
    <>
      <NewBuildDrawer
        guid={mobile_app.guid}
        onClose={toggleNewBuild.bind(null, false)}
        onSave={handleBuildSave}
        show={show_new_build}
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 30 }}>
        <Button inline={true} onClick={toggleNewBuild.bind(null, true)}>
          New Build
        </Button>
      </div>

      <Table
        apiPagination={{ ...headers, current_page: parseInt(page, 10), onClick: setPage }}
        columns={[
          {
            id: 'guid',
            label: 'GUID'
          },
          {
            id: 'github_release_version',
            label: 'Version'
          },
          {
            id: 'created_at',
            label: 'Created Date',
            render: build => {
              return <>{format(new Date(build.created_at), 'MM/dd/yyyy h:mm:ss a')}</>;
            }
          }
        ]}
        data={builds}
        onRowClick={page => {
          navigate(`${page.guid}`);
        }}
      />
    </>
  ) : (
    <Loader />
  );
};

Builds.propTypes = {
  builds: PropTypes.array,
  headers: PropTypes.object,
  loadBuilds: PropTypes.func,
  loading: PropTypes.bool,
  mobile_app: PropTypes.object,
  page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setPage: PropTypes.func
};

export default Builds;
